import { CircularProgress } from '@material-ui/core';
import React from 'react';

const Spinner = ({ style, size = 40 }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...style,
      }}
    >
      <CircularProgress style={{ color: '#38bdf8' }} size={size} />
    </div>
  );
};

export default Spinner;
